import React, { useState, useEffect } from "react";
import AppContext, { AppContextType, IAppContext, defaultAppState } from "../Contexts/AppContext";

interface AppContextProviderProps {
  children: React.ReactNode;
}

const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => {
  const [appState, setAppState] = useState<AppContextType>(defaultAppState);

  const [contextValue, setContextValue] = useState<IAppContext>({
    appState,
    setDarkMode: (isDark: boolean) =>
      setAppState((currentState) => ({
        theme: {
          ...currentState.theme,
          isDark,
        },
      })),
  });

  useEffect(() => {
    setContextValue((currentValue) => ({
      ...currentValue,
      appState,
    }));
  }, [appState]);

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};

export default AppContextProvider;
